var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('statsbox', {
    attrs: {
      "category": "Customers",
      "actions": _vm.actions1
    }
  }, [_vm._v(_vm._s(_vm.total.users))])], 1), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('statsbox', {
    attrs: {
      "category": "Interactions",
      "color": "warning",
      "chartData": _vm.stats.interactions
    }
  }, [_vm._v(_vm._s(_vm.total.interactions))])], 1), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('statsbox', {
    attrs: {
      "category": "Billing",
      "color": "success",
      "chartData": _vm.stats.revenue
    }
  }, [_vm._v(_vm._s(_vm.total.revenue))])], 1), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('statsbox', {
    attrs: {
      "category": "Compaints",
      "color": "danger",
      "chartData": _vm.stats.orders
    }
  }, [_vm._v(_vm._s(_vm.total.orders))])], 1)]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Conversation Topics")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("5 Most Interacted Topics")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [(_vm.userAccessLevel != "agent") ? _c('b-dropdown', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.xlsx
    }
  }, [_vm._v("Download as xlsx")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_vm._v("Download as pdf")])], 2) : _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v(" Export as pdf")])], 1)]), _c('br'), _c('app-table', {
    attrs: {
      "data": _vm.tableItems1,
      "label": _vm.tableFields1,
      "small": "small"
    }
  })], 1), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Real Time Interactions")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("5 Most Recent Interactions")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  })])], 1)]), _c('br'), _c('app-table', {
    attrs: {
      "data": _vm.tableItems2,
      "label": _vm.tableFields2,
      "small": "small",
      "rowClick": "rowClick"
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b11ac80e","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 884
// module chunks = 1